import { useTranslation } from "react-i18next";
import TransfetCountInput from "./TransfetCountInput";
import { Button, Form } from "react-bootstrap";
import { Field, Formik } from "formik";
import CounterLabel from "./CounterLabel";
import { useToast } from "context/ToastContext";
import { useEffect, useRef } from "react";
import { useAuth } from "context/AuthContext";
import useSettingsParams from "hooks/useSettingsParams";
import { splitsStockByPurchasePrice } from "utils/helpers/access/hasUserAccess";
import SolarIcon from 'components/icons/SolarIcon';

const distributePresetCount = (stocks: { stock?: number }[] | null, total: number) => {
    let remain = Number(total) || 0;
    if (!(remain > 0) || !stocks?.length) return stocks?.map(() => '') || [''];
    return stocks.map((row) => {
        const stock = Number(row?.stock) || 0;
        if (!(remain > 1e-6) || !(stock > 0)) return '';
        const take = Math.min(remain, stock);
        remain -= take;
        return take;
    });
};

const AddTransferFormCounter = ({addProduct, setAddProduct, productStocks, setATransfer, presetCount = null, presetProductId = null}: any) => {

    const { t } = useTranslation(['Warehouses', 'common']);
    const { showToast } = useToast();
    const { auth } = useAuth();
    const params = useSettingsParams();
    const splitByPrice = splitsStockByPurchasePrice(auth?.user, Boolean(params.ignoreWarehousePrice));
    const refInputFirst = useRef<HTMLInputElement | null>(null);

    useEffect(()=>{
        if (refInputFirst.current) refInputFirst.current.focus();
    },[refInputFirst])

    return (
 
        <Formik   
            initialValues={{
                setCount:
                    Number(addProduct?.value) === Number(presetProductId) && Number(presetCount) > 0
                        ? distributePresetCount(productStocks, Number(presetCount))
                        : [''],
                setDescription: '',
            }}
            onSubmit={async (values) => {

                if (!values.setCount.find((c) => Number(c) > 0)) return showToast(t('messInputCount'), 'danger');

                // Додаємо до продуктів поле setCount і видаляємо там де їх немає 
                const products = productStocks
                                    ?.map((p,i)=>({...p, 
                                        setCount:values?.setCount?.[i]||null,
                                        setDescription: values?.setDescription||null
                                    }))
                                    ?.filter(p=>p.setCount);

                const nextRows = splitByPrice
                    ? products.map((product) => ({
                            setId: 0,
                            product: {
                                ...addProduct,
                                ID: addProduct.value,
                            },
                            coming: {
                                cCount: product.setCount,
                                price: product.operPrice || 0,
                                priceSale: product.operPriceSale || 0,
                                priceRate: product.operPriceRate || 0,
                                priceSaleRate: product?.operPriceSaleRate || 0,
                                cDescription: product?.setDescription || '',
                            },
                        }))
                    : [{
                            setId: 0,
                            product: {
                                ...addProduct,
                                ID: addProduct.value,
                            },
                            coming: {
                                cCount: products.reduce((sum, p) => sum + Number(p.setCount || 0), 0),
                                price: 0,
                                priceSale: 0,
                                priceRate: 0,
                                priceSaleRate: 0,
                                cDescription: products[0]?.setDescription || '',
                            },
                        }];

                setATransfer((prev) => [
                    ...prev.filter((p) => p.product.ID !== addProduct.value),
                    ...nextRows,
                ]);

                setAddProduct(null);
                
            }}>

            {({ handleSubmit, isSubmitting, setFieldValue, values }) => (
                <form onSubmit={handleSubmit}>
                    <div className="off-transfer-count-form-wrap">
                        <div className="off-transfer-count-form px-1">
                            <CounterLabel showPrice={splitByPrice}/>
                            {productStocks?.map((pStock,index)=>{
                                return (<TransfetCountInput
                                            ref={index===0 ? refInputFirst : null}
                                            setFieldValue={setFieldValue}
                                            value={values.setCount[index]}
                                            key={`${addProduct?.value}-${pStock.operPrice}-${pStock.operPriceRate}-${index}`}
                                            index={index}
                                            stockCount={pStock}
                                            splitByPrice={splitByPrice}/>)
                            })}
                        </div>
                    </div>

                    <Form.Group className="mb-3 px-1">
                        <label className="form-label text-muted">{t('labelDescription')}</label>
                        <Field
                            name="setDescription"
                            as="textarea"
                            rows="4"
                            className="form-control"/>
                    </Form.Group>

                    <div className="mt-3 d-flex justify-content-end gap-2">
                        <Button
                            type="button"
                            variant="light"
                            size="sm"
                            onClick={() => setAddProduct(null)}
                        >
                            {t('buttons.cancel', { ns: 'common' })}
                        </Button>
                        <Button type="submit"
                            variant="primary"
                            size="sm">
                                <SolarIcon name="plus-lg" className="me-1 fs-14" />{t('btnAdd')}
                        </Button>
                    </div>
                </form>)}
        </Formik>)
}

export default AddTransferFormCounter;